import { gql } from 'graphql-request'

export default gql`
  mutation updateCardRecipient($input: CardRecipientInput!, $handle: Int!) {
    applications {
      cardUnlock {
        cardRecipientUpdate(input: $input, handle: $handle) {
          name
          handleRecipient
          handleCard
          handleRegistration
          code
          type
          dependentType
          blocked
          nameMother
          cpf
          email
          address {
            zipcode
            handleResidential
            handleMail
            street
            neighborhood
            city
            state
            number
            complement
            handleState
            handleCity
            phoneDDD
            phonePrefix
            phoneNumber
            cellPhoneDDD
            cellPhonePrefix
            cellPhoneNumber
          }
        }
      }
    }
  }
`
